var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-md-center text-center pt-5 pb-5"},[_c('b-col',{attrs:{"col":"","md":"10"}},[_c('preloader')],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }